import * as React from 'react';
import { connect } from 'react-redux';

import { getBalance } from '~/apps/shared/actions/balance'

import TransactionBalanceBlock from '../../components/transactions/TransactionBalanceBlock';
import PopupFunds from '../../components/transactions/PopupFunds';


class TransactionBalance extends React.Component<any, any> {
  state = {
    isPopupVisible: false,
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getBalance());
  }

  onClose = (e) => {
    this.setState({ isPopupVisible: false });
  }

  onShow = () => {
    this.setState({ isPopupVisible: true });
  }

  render() {
    const { balance } = this.props;
    const { isPopupVisible } = this.state;

    return (
      <React.Fragment>
        <TransactionBalanceBlock
          manual={true}
          loading={balance.loading}
          balance={balance.balance}
          onShow={this.onShow}
        />
        {isPopupVisible && (
          <PopupFunds onClose={this.onClose} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    balance: state.shared.balance,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionBalance);
